import {Separator} from 'platform/components';
import {getValueByDevice, Space, useDevice, VStack} from 'platform/foundation';

import {featureFlags} from '@dms/feature-flags';
import {VehicleForm as VFKit, VehicleFormDefaultLayout} from '@dms/features/vehicle-forms-kit';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {usePermissions} from '@dms/shared';

import {useNavigate} from 'shared/web';

import {AdditionalInfoWidget} from '../components/AdditionalInfoWidget';

export function Features() {
  const navigate = useNavigate();

  const device = useDevice();
  const isExpandable = getValueByDevice(device, true, true, true, false);

  const [canReadBusinessCase] = usePermissions({
    permissionKeys: ['businessCaseRead'],
  });

  return (
    <VehicleFormDefaultLayout>
      <VehicleFormDefaultLayout.Left>
        <VStack spacing={4}>
          <VFKit.Section
            data-testid="features"
            title={i18n.t('general.labels.allFeatures')}
            isExpandable={isExpandable}
          >
            <VFKit.ShowWhen when={canReadBusinessCase}>
              <VFKit.FeatureSelector />
            </VFKit.ShowWhen>

            <Separator spacing={2} />

            <VFKit.ShowWhen whenFeatureEnabled={featureFlags.SALES_FEATURES_ADDITIONAL_INFO}>
              <VFKit.FeaturesByManufacturerTextarea />
            </VFKit.ShowWhen>
          </VFKit.Section>
        </VStack>
      </VehicleFormDefaultLayout.Left>
      <VehicleFormDefaultLayout.Right>
        <VFKit.SubSection data-testid="additional-info">
          <AdditionalInfoWidget />
        </VFKit.SubSection>
        <Space vertical={4} />
        <VFKit.ShowWhen when={canReadBusinessCase} vehicleVariants={['sale']}>
          <VFKit.SubSection
            data-testid="cebia-features-widgets"
            title={i18n.t('entity.vehicle.labels.integrations')}
            isExpandable={isExpandable}
            useCard
            cardVariant={isExpandable ? 'default' : 'inlineWhite'}
            actions={[
              {
                variant: 'link',
                type: 'button',
                leftIcon: 'action/settings',
                onClick: () => navigate(settingsRoutes.vehicleServices),
                title: i18n.t('general.labels.settings'),
              },
            ]}
          >
            <VFKit.Suspense>
              <VFKit.CebiaAutofillFeaturesWidget />
            </VFKit.Suspense>
          </VFKit.SubSection>
        </VFKit.ShowWhen>

        <Space vertical={4} />

        <VFKit.ShowWhen when={canReadBusinessCase} vehicleVariants={['sale']}>
          <VFKit.SubSection
            data-testid="feature-market-analysis"
            title={i18n.t('entity.vehicle.labels.featureMarketAnalysis')}
            useCard
            cardVariant={isExpandable ? 'default' : 'inlineWhite'}
            isExpandable={isExpandable}
          >
            <VFKit.Suspense>
              <VFKit.FeatureMarketAnalysisWidget />
            </VFKit.Suspense>
          </VFKit.SubSection>
        </VFKit.ShowWhen>
      </VehicleFormDefaultLayout.Right>
    </VehicleFormDefaultLayout>
  );
}
